import CrudTable from "../../../crud/CrudTable"
import {statebillService as service} from "../../../../services"

const initFilter =  {
    name : null,
    code: null,
};


export default function Statebill() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       col: 4
      },
  ];


  return (
    <CrudTable
          service={service}
          urledit={"/statebill/edit/"}
          urlnew={"/statebill/new/"}
          filter={initFilter}
          i18n={"statebill"}
          fieldstable={["id","name"]}
          estructureForm={createEstructureFilter} />
  );
}
